import { render, staticRenderFns } from "./MailsLog.vue?vue&type=template&id=ff26922a&"
import script from "./MailsLog.vue?vue&type=script&lang=js&"
export * from "./MailsLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports